(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('ParamTableauDeleteController',ParamTableauDeleteController);

    ParamTableauDeleteController.$inject = ['$uibModalInstance', 'entity', 'ParamTableau'];

    function ParamTableauDeleteController($uibModalInstance, entity, ParamTableau) {
        var vm = this;

        vm.paramTableau = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ParamTableau.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
